/* generated using openapi-typescript-codegen -- do not edit */

/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */
import type { FeatureMappingRequest } from "./FeatureMappingRequest"

export type NodeCreateRequest = {
  /**
   * * `ruleset` - ruleset
   * * `taglist` - taglist
   * * `filter` - filter
   * * `label` - label
   * * `scorecardset` - scorecardset
   * * `decision` - decision
   * * `program` - program
   * * `calculator` - calculator
   * * `project` - project
   * * `script` - script
   * * `loop-start` - loop-start
   * * `loop-end` - loop-end
   */
  node_type: NodeCreateRequest.node_type
  return_label?: string
  description?: string
  /**
   *
   * The condition that will be evaluated in a FilterNode or RulesetNode.
   *
   * It must be a string in the following format:
   * "((<Feature name> <Operator> <Operand>))"
   * The whole condition should be wrapped in parenthesis and each condition inside it must also be wrapped in
   * parenthesis.
   * Ex: "((age > 22))"
   *
   * <Feature name>:
   * The name of the prediction feature that the condition will apply to or computed feature from calculator
   * nodes. The name should be a stringof the path to the JSON feature separated
   * by the :feature_nesting_separator: character. e.g:
   * ```json
   *
   * {{"name": "John", "address" :{{ "street" : "Baker Street", "city": "London"}}, "age": 20}}
   *
   * ```
   * :condition: address.street = "Baker Street"
   * :feature_nesting_separator: '.'
   *
   * <Operator>:
   * The operator that will be applied to the feature value. Possible values are <=, >=, =, !=, >, <, in, not in, contains, not contains, between
   *
   * <Operand>:
   * The operand that will be compared to the feature value. It must be compatible with the feature type. This is the list
   * of the supported types, | represents OR:
   *
   * 'string' -> str
   * A string type that is indicated by surrounding single quotes
   *
   * 123 | -123 -> int
   * An integer type that is indicated by numeric digits without decimal places
   *
   * 123.0 | -123.0 -> float
   * A float type is indicated by numeric digits followed by `.` to indicate decimal values
   *
   * true | false -> bool
   * A boolean type that is indicated by just either `true` or `false` without quotes
   *
   * null -> null
   * A null value type is simply indicated by `null` without quotes
   *
   * 2022-10-31 -> Date
   * A date type in ISO format: YYYY-MM-DD.
   *
   * [1, 2, 3] -> list
   * A list type containing several values of the previously defined types. All values must be of the same
   * type.
   *
   * $file -> file
   * A reserved token used to denote a list of values that is passed under the condition_list_files field.
   *
   * "feature.key.path" | feature.key.path -> Feature name
   * A feature name is indicated by a string of the path to the JSON feature separated by the
   * :feature_nesting_separator: character. the feature name can be surrounded by double quotes or not.
   * If its not surrounded by double quotes then the feature name must not contain single quotes, spaces or commas
   *
   */
  condition?: string
  /**
   * Represents an arithmetic operation between a set of features. These features can be of the original prediction features or dynamic features generated during the workflow.
   * Supports the following arithmetic operations: [+, -. *, /] in addition to the usage of parenthesis.
   * Supports subtraction operations between date objects. Date objects must be in the following format: YYYY-MM-DD(ex: 2022-01-01). Examples: '(2022-01-01 - 2021-01-01)'.
   * We also support the 'TODAY' token to use when the equation is executed. Example: `(TODAY - 2022-01-01)`.
   * Each equation must be wrapped in an opening and closing parenthesis regardless of the content.
   * Examples: '(a + b / d)', '((a + b) / d)', '((a + b) / (c + d))'.
   */
  equation?: string
  /**
   * The key to the node's output stored in calculated_features and accessed throughout the workflow
   */
  computed_feature_name?: string
  feature_nesting_separator?: string
  /**
   * Carries the index (0-based) of a node in the nodes list
   */
  true_route?: number
  /**
   * Carries the index (0-based) of a node in the nodes list
   */
  false_route?: number
  ruleset?: string
  taglist?: string
  /**
   * Carries the index (0-based) of a node in the nodes list
   */
  uncovered_route?: number
  scorecard_set?: string
  /**
   * Carries the index (0-based) if a node in the list
   */
  resolution_route?: number
  program?: string
  project?: string
  script?: string
  /**
   * The mapping between the workflow's features and the object referenced by the node
   */
  feature_mappings?: Array<FeatureMappingRequest>
  /**
   * Carries the index (0-based) of a node in the nodes list denoting the first node in a loop
   */
  start_node?: number
  /**
   * A list of strings specifying the features this loop will process
   */
  input_lists?: Array<string>
  /**
   * A loop's name
   */
  name?: string
  /**
   * Carries the index (0-based) of a loop-end node in the nodes list
   */
  loop_end_node?: number
  /**
   * * `PARALLEL` - Parallel Iteration
   * * `COMBINED` - Combined Lists
   */
  strategy?: NodeCreateRequest.strategy
}
export namespace NodeCreateRequest {
  /**
   * * `ruleset` - ruleset
   * * `taglist` - taglist
   * * `filter` - filter
   * * `label` - label
   * * `scorecardset` - scorecardset
   * * `decision` - decision
   * * `program` - program
   * * `calculator` - calculator
   * * `project` - project
   * * `script` - script
   * * `loop-start` - loop-start
   * * `loop-end` - loop-end
   */
  export enum node_type {
    RULESET = "ruleset",
    TAGLIST = "taglist",
    FILTER = "filter",
    LABEL = "label",
    SCORECARDSET = "scorecardset",
    DECISION = "decision",
    PROGRAM = "program",
    CALCULATOR = "calculator",
    PROJECT = "project",
    SCRIPT = "script",
    LOOP_START = "loop-start",
    LOOP_END = "loop-end",
  }
  /**
   * * `PARALLEL` - Parallel Iteration
   * * `COMBINED` - Combined Lists
   */
  export enum strategy {
    PARALLEL = "PARALLEL",
    COMBINED = "COMBINED",
  }
}
